(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    

document.getElementById('ContactFooter').addEventListener('submit', function(event) {
    event.preventDefault(); 
    const email = document.querySelector('[name="contact[email]"]').value;
    console.log('email:: ',email);
    const payload = JSON.stringify({
        data: {
            type: 'subscription',
            attributes: {
                profile: {
                    data: {
                        type: 'profile',
                        attributes: {
                            email: email
                        }
                    }
                }
            },
            relationships: {
                list: {
                    data: {
                        type: 'list',
                        id: 'RjEVra'
                    }
                }
            }
        }
    });
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'REVISION': '2024-07-15'
        },
        body: payload
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=TXH2kC', options)
        .then(response => {
            if (!response.ok) {
                throw new Error(`Network response was not ok. Status: ${response.status}`);
            }
            return response.text();
        })
        .then(text => {
            if (text) {
                try {
                    const jsonResponse = JSON.parse(text);
                } catch (e) {
                    console.error('Failed to parse JSON:', e);
                }
            } else {
                console.log('Empty response body');
            }
        })
        .catch(err => {
            console.error('Error:', err);
        });
});  

  } catch(e) { console.error(e); }
})();
})();
